/**
 * Whether a click on a link is the plain one the app should handle itself.
 *
 * IN `lib/` FOR THE SAME REASON views.js IS: node's test runner cannot parse
 * JSX, so the one decision ViewLink makes has to be a plain function.
 *
 * Only a bare primary-button click is ours. Ctrl/Cmd (new tab), Shift (new
 * window), Alt (download), the middle button, and a click something upstream
 * already handled all belong to the browser, which is the whole point of the
 * element being a real <a href>.
 */
export function isPlainClick(e) {
  if (!e) return false;
  if (e.defaultPrevented) return false;
  if (e.button !== undefined && e.button !== 0) return false;
  return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey);
}
